import { ChangeDetectionStrategy, Component, Input, OnChanges, inject } from '@angular/core';
import { GalleryDto, Section, TenantDto } from '@nusign/picflow-backend-types';
import { fontSizeMap } from '../../../consts';
import { CleanUserGeneratedHtmlService } from '../../../services/clean-user-generated-html.service';

@Component({
  selector: 'app-text-section',
  templateUrl: './text-section.component.html',
  styleUrls: ['./text-section.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextSectionComponent implements OnChanges {
  private cleanUserGeneratedHtmlService = inject(CleanUserGeneratedHtmlService);
  @Input() section: Section;
  @Input() gallery: GalleryDto;
  @Input() darkBackground: boolean;
  @Input() noPadding: boolean;
  textParagraph: string;
  paragraphFontSize: 'small' | 'medium' | 'large';
  titleFontSize: 'small' | 'medium' | 'large';

  ngOnChanges() {
    this.textParagraph = this.cleanUserGeneratedHtmlService.clean(this.section.text_paragraph);
    if (!this.section.width) this.section.width = 960;
    this.paragraphFontSize = <'small' | 'medium' | 'large'>(
      (Object.keys(fontSizeMap).find(key => fontSizeMap[key] === this.section.text_paragraph_typography.font_size) ||
        'small')
    );
    this.titleFontSize = <'small' | 'medium' | 'large'>(
      (Object.keys(fontSizeMap).find(key => fontSizeMap[key] === this.section.text_title_typography.font_size) ||
        'small')
    );
  }

  get tenant() {
    return this.gallery?.tenant as TenantDto;
  }
}
